import { useGlobal } from '@rcg/ui-react';

const useDictionary = (dictionary) => {
  const { renderContent } = useGlobal();
  const useLocalDictionary = process.env.REACT_APP_USE_LOCAL_DICTIONARY === 'true';

  return (entry) => {
    // eslint-disable-next-line no-prototype-builtins
    if (dictionary.hasOwnProperty(entry)) {
      const { key, defaultValue } = dictionary[entry];

      // If the switch is disabled, use only AEM (normal behavior)
      if (!useLocalDictionary) {
        return renderContent(key, defaultValue);
      }

      // If the switch is enabled: prioritize local dictionary.json
      // If defaultValue exists locally, use it
      if (defaultValue) {
        return defaultValue;
      }

      // If it doesn't have defaultValue, search in AEM as fallback
      return renderContent(key, defaultValue);
    }

    return null;
  };
};

export default useDictionary;
